import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { loginWithEmailAndPassword } from '../../firebase';
import { useContextMenu } from '../shared/ContextMenu';
import '../../css/Auth.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    // Where to send the user after a successful sign-in. Set when they arrive
    // here from a public board ("Sign In" button), so they return to that board
    // instead of always landing on the home page.
    const redirectTo = location.state?.from || '/';

    const { handleContextMenu, ContextMenuComponent } = useContextMenu([
        {
            label: "Register",
            icon: <i className="fas fa-user-plus"></i>,
            onClick: () => navigate("/register"),
        },
    ]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await loginWithEmailAndPassword(email, password);
            navigate(redirectTo, { replace: true });
        } catch (err) {
            setError(err.message?.replace('Firebase: ', '') || 'Login failed');
        }
        setLoading(false);
    };

    return (
        <div className="Auth" onContextMenu={handleContextMenu}>
            <div className="Auth__container">
                <div className="Auth__header">
                    <h1 className="Auth__brand">Bluebird</h1>
                    <p className="Auth__subtitle">Task Management</p>
                </div>

                <form className="Auth__form" onSubmit={handleLogin}>
                    <h2 className="Auth__title">Sign In</h2>

                    {error && <div className="Auth__error">{error}</div>}

                    <div className="Auth__field">
                        <label className="Auth__label">Email</label>
                        <input
                            className="Auth__input"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="your@email.com"
                            required
                        />
                    </div>

                    <div className="Auth__field">
                        <label className="Auth__label">Password</label>
                        <input
                            className="Auth__input"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                        />
                    </div>

                    <button className="Auth__button" type="submit" disabled={loading}>
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>

                    <p className="Auth__footer">
                        Don't have an account? <Link to="/register" className="Auth__link">Create one</Link>
                    </p>
                </form>
            </div>
            {ContextMenuComponent}
        </div>
    );
};

export default Login;
